import React from 'react'
import Img from 'gatsby-image'

import { Grid } from '@material-ui/core'
import useStyles from './styles'

const SectionContainer = ({
  children,
  fullHeight,
  sectionID,
  sectionBG,
  backgroundColor,
  blured,
}) => {
  const { sectionContainer, section, bg } = useStyles({
    fullHeight,
    sectionBG,
    backgroundColor,
    blured,
  })
  return (
    <section id={sectionID} className={section}>
      {sectionBG && <Img className={bg} fluid={sectionBG} />}
      <Grid className={sectionContainer}>{children}</Grid>
    </section>
  )
}

export default SectionContainer
